import VaporUploader from "../VaporUploader";
import VaporUploaderProps from "../VaporUploader";

export const Uploader = VaporUploader;
export interface UploaderProps {
  VaporUploaderProps;
}
